import React, {useCallback, useMemo} from "react";
import CustomStepper from "../../../../components/common/CustomStepper";
import { CnyStepsDataV2 } from "../../const";
import { Description, Title, Wrapper } from "./styles";
import {useAppDispatch, useAppSelector} from "../../../../app/hooks";
import { setStep } from "../../redux/formDataSlice";


const ChinaPayoutV2 = () => {
  const dispatch = useAppDispatch();
  const step = useAppSelector((state) => state.formData.step);
  const getSavedData = useAppSelector((state) => state.formData.cnyData);


  const filteredSteps = useMemo(() => {
    if (getSavedData?.paymentMethod === "alipay") {
      return CnyStepsDataV2.filter((item) => (item.title !== "Payment details"))
    }
    return CnyStepsDataV2;
  }, [getSavedData]);



  const stepsItems = filteredSteps.map((step, index) => ({
    id: `step-${index}`,
    title: step.title,
    description: step.description,
    stepTitle: step.stepTitle,
    stage: index,
  }));


  const handleChangeStep = useCallback(
    (index) => {
      if (index >= 0 && index < filteredSteps.length) {
        dispatch(setStep(index));
      }
    },
    [dispatch]
  );

  const renderStepContent = useCallback(() => {
    const currentStepData = filteredSteps[step];
    const StepComponent = currentStepData?.component;

    if (StepComponent) {
      return (
        <StepComponent
          handleNext={() => handleChangeStep(step + 1)}
          handlePrevious={() => handleChangeStep(step - 1)}
        />
      );
    }

    return null;
  }, [step, getSavedData]);

  return (
    <Wrapper>
      <CustomStepper stages={stepsItems} step={step} setStep={setStep} />
      <Title>{stepsItems[step]?.stepTitle}</Title>
      <Description>{stepsItems[step]?.description}</Description>
      {renderStepContent()}
    </Wrapper>
  );
};

export default ChinaPayoutV2;
